module.exports = __webpack_public_path__ + "img/spIcon2.3d634588.png";